define(['text!./templates/lob-selection.html', 'underscore'],
    (templateStr, _)=> {
        return [()=> {
            return {
                scope: {
                    model: '=gwLobSelection',
                    form: '='
                },
                template: templateStr,
                controller: ['$scope', 'lobConfig', ($scope, lobConfig) => {
                    const lobMap = {'PersonalAuto': 'pa', 'Homeowners': 'ho'};

                    $scope.moreThanOneLob = lobConfig.lobs.length > 1;

                    $scope.selectLob = (lob)=> {
                        if (_.contains(lobConfig.lobs, lobMap[lob])) {
                            $scope.model.productCode.value = lob;
                        }
                    };
                }]
            };
        }];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/integration/quoteandbind/directives/LobSelection.js